import React from 'react';
import { observer } from 'mobx-react-lite';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

const QuestionLayout = observer(function QuestionLayout({ faq }) {
  let answerComponents = faq.answer.map((answer) => (
    <p key={answer} className="pt-4">
      {answer}
    </p>
  ));

  if (faq.link) {
    answerComponents = (
      <p className="pt-8">
        {faq.answer}{' '}
        <a href={faq.link} className="cornell-link">
          click here.
        </a>
      </p>
    );
  }

  let expand = '+';

  if (faq.showAnswer) {
    expand = '-';
  }

  return (
    <div className="my-8">
      <Accordion className="fs-base p-4 faq-questions charcoal-text">
        <AccordionSummary
          expandIcon={
            <div className="faq-questions__expand font-semibold">{expand}</div>
          }
          onClick={faq.toggleShowAnswer}
        >
          <p className="font-semibold mb-0">{faq.question}</p>
        </AccordionSummary>
        <AccordionDetails>{answerComponents}</AccordionDetails>
      </Accordion>
    </div>
  );
});

export default QuestionLayout;
